import { render, staticRenderFns } from "./AUDIODISPLAY.vue?vue&type=template&id=2795eb61&scoped=true&"
import script from "./AUDIODISPLAY.vue?vue&type=script&lang=js&"
export * from "./AUDIODISPLAY.vue?vue&type=script&lang=js&"
import style0 from "./AUDIODISPLAY.vue?vue&type=style&index=0&id=2795eb61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795eb61",
  null
  
)

export default component.exports